export const selectUserData = (state) => state.user.userData;

export const selectIsUserVerificationFinished = (state) => state.user.isUserVerificationFinished;
